/**
 * Centralized configuration of the company information.
 * Makes it easy to update every reference across the application.
 */

export interface CompanyConfig {
    legalName: string;
    brandName: string;
    productName: string;
    productTagline: string;
    domain: string;
    copyrightYear: number;
    copyrightText: string;
    auth: {
        loginWelcome: string;
        loginDescription: string;
        teamRestriction: string;
        termsAcceptance: string;
    };
    colors: {
        primary: string;
        secondary: string;
        accent: string;
    };
    urls: {
        website: string;
        support: string;
        terms: string;
        privacy: string;
    };
    legal: {
        capital: string;
        siren: string;
        rcs: string;
        address: string;
        email: string;
        phone: string;
        publicationDirector: string;
        host: string;
        dpo: {
            name: string;
            email: string;
            phone: string;
        };
    };
}

/** Company information (identity, legal notices, URLs) used throughout the application. */
export const companyConfig: CompanyConfig = {
    legalName: "Campel Communication",
    brandName: "Campel's & Co",

    productName: "Tools Box SEO",
    productTagline: "Connectez-vous pour accéder à vos outils SEO",

    domain: "tools-box-seo.com",

    copyrightYear: new Date().getFullYear(),
    copyrightText: "Tous droits réservés",

    auth: {
        loginWelcome: "Bienvenue",
        loginDescription: "Utilisez votre compte Google pour vous connecter",
        teamRestriction: "Réservé aux membres de l'équipe Campel's & Co",
        termsAcceptance: "En vous connectant, vous acceptez notre politique de confidentialité",
    },

    colors: {
        primary: "principal.blue",
        secondary: "brand.ytg.main",
        accent: "secondary.orange",
    },

    urls: {
        website: "https://tools-box-seo.com",
        support: "mailto:support@campel-communication.com",
        terms: "/terms",
        privacy: "/confidentialite",
    },

    legal: {
        capital: "30 500 €",
        siren: "820 327 880",
        rcs: "Lille",
        address: "2 rue du Priez, 59800 Lille",
        email: "contact@campels-co.com",
        phone: "06 43 11 30 05",
        publicationDirector: "Joseph Campel",
        host: "Campel Communication (auto-hébergement), 2 rue du Priez, 59800 Lille, France",
        dpo: {
            name: "Christèle Regnier",
            email: "christele@campels-co.com",
            phone: "06 70 29 31 29",
        },
    },
};

/** Helper that builds the full copyright text. */
export const getCopyrightText = (): string => {
    return `© ${companyConfig.copyrightYear} ${companyConfig.legalName} - ${companyConfig.copyrightText}`;
};

/** Helper that returns the full product name. */
export const getFullProductName = (): string => {
    return `${companyConfig.brandName} ${companyConfig.productName}`;
};
